/**
 * Injects color swatches (from shopify--color-pattern metaobject) into bundle app Color pills.
 * Runs when #bundlerAppProducts exists; supports dynamically loaded bundle content.
 */
(function () {
  var map = typeof window.__colorPatternMap !== 'undefined' ? window.__colorPatternMap : {};
  var mapByHex = typeof window.__colorPatternMapByHex !== 'undefined' ? window.__colorPatternMapByHex : {};
  var flagMap = typeof window.__flagPatternMap !== 'undefined' ? window.__flagPatternMap : {};

  function debugLogMaps() {
    if (typeof window !== 'undefined' && window.__BUNDLER_COLOR_DEBUG !== true) return;
    if (typeof console === 'undefined' || !console.log) return;
    var locale = (document.documentElement.getAttribute('lang') || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    var labelKeys = Object.keys(map);
    var withImage = [];
    var withColorOnly = [];
    labelKeys.forEach(function (k) {
      var e = map[k];
      if (e && e.image) withImage.push(k); else if (e && e.color) withColorOnly.push(k);
    });
    var hexWithImage = Object.keys(mapByHex).filter(function (k) { return mapByHex[k] && mapByHex[k].image; });
    console.log('[bundler-color-swatches] Current locale: "' + locale + '" (from <html lang>)');
    console.log('[bundler-color-swatches] Color labels in map for this context (' + labelKeys.length + '):', labelKeys);
    console.log('[bundler-color-swatches] Labels WITH image (' + withImage.length + '):', withImage);
    console.log('[bundler-color-swatches] Labels color-only, no image (' + withColorOnly.length + '):', withColorOnly);
    console.log('[bundler-color-swatches] Hex keys with image (byHex, ' + hexWithImage.length + '):', hexWithImage);
  }

  function colorToString(color) {
    if (!color) return '';
    if (typeof color === 'string') return color;
    if (typeof color === 'object' && color !== null) {
      if (color.hex) return color.hex;
      if (color.rgb) return 'rgb(' + color.rgb + ')';
    }
    return '';
  }

  var fallbackColors = {
    white: '#ffffff',
    black: '#000000',
    blue: '#0000ff',
    red: '#ff0000',
    yellow: '#ffff00',
    green: '#008000',
    orange: '#ffa500',
    pink: '#ffc0cb',
    navy: '#000080',
    'navy blue': '#000080',
    'light blue': '#add8e6',
    purple: '#800080',
    brown: '#8b4513',
    gray: '#808080',
    grey: '#808080',
    fehér: '#ffffff',
    fekete: '#000000',
    kék: '#0000ff',
    piros: '#ff0000',
    sárga: '#ffff00',
    zöld: '#008000',
    narancs: '#ffa500',
    rózsaszín: '#ffc0cb',
    sötétkék: '#000080',
    világoskék: '#add8e6',
    /* Slovak */
    biela: '#ffffff',
    čierna: '#000000',
    modrá: '#0000ff',
    červená: '#ff0000',
    žltá: '#ffff00',
    zelená: '#008000',
    oranžová: '#ffa500',
    ružová: '#ffc0cb',
    tmavomodrá: '#000080',
    svetlomodrá: '#add8e6',
    /* Czech */
    bílá: '#ffffff',
    černá: '#000000',
    modrá: '#0000ff',
    červená: '#ff0000',
    žlutá: '#ffff00',
    zelená: '#008000',
    oranžová: '#ffa500',
    růžová: '#ffc0cb',
    tmavěmodrá: '#000080',
    světlemodrá: '#add8e6',
    /* Croatian */
    bijela: '#ffffff',
    crna: '#000000',
    plava: '#0000ff',
    crvena: '#ff0000',
    žuta: '#ffff00',
    zelena: '#008000',
    narančasta: '#ffa500',
    ružičasta: '#ffc0cb',
    tamnoplava: '#000080',
    svjetloplava: '#add8e6',
    /* Polish */
    biały: '#ffffff',
    czarny: '#000000',
    niebieski: '#0000ff',
    czerwony: '#ff0000',
    żółty: '#ffff00',
    zielony: '#008000',
    pomarańczowy: '#ffa500',
    różowy: '#ffc0cb',
    ciemnoniebieski: '#000080',
    jasnoniebieski: '#add8e6',
    /* Romanian */
    alb: '#ffffff',
    negru: '#000000',
    albastru: '#0000ff',
    roșu: '#ff0000',
    galben: '#ffff00',
    verde: '#008000',
    portocaliu: '#ffa500',
    roz: '#ffc0cb',
    bleumarin: '#000080',
    albastrudeschis: '#add8e6',
    /* Slovenian */
    bela: '#ffffff',
    črna: '#000000',
    modra: '#0000ff',
    rdeča: '#ff0000',
    rumena: '#ffff00',
    zelena: '#008000',
    oranžna: '#ffa500',
    roza: '#ffc0cb',
    temnomodra: '#000080',
    svetlomodra: '#add8e6'
  };

  /** When fallback hex is not in map (or has no image), try these store hexes to resolve image. E.g. "világoskék" -> #add8e6 not in map, try #90d5ff (light blue in store). */
  var fallbackHexAliases = {
    '#add8e6': ['#90d5ff'],
    '#000080': ['#282099'],
    '#0000ff': ['#005bd3'],
    '#ff0000': ['#f61f1f'],
    '#008000': ['#05aa3d'],
    '#ffff00': ['#ffe500'],
    '#ffa500': ['#ff8a00', '#f0ae3d']
  };

  function getEntry(key) {
    if (!key) return null;
    var entry = map[key];
    if (entry) return entry;
    var keyLower = key && key.toLowerCase ? key.toLowerCase().trim() : key;
    if (map[keyLower]) return map[keyLower];
    var keyNoSpaces = key.replace(/\s+/g, '');
    if (map[keyNoSpaces]) return map[keyNoSpaces];
    var keyHyphen = key.replace(/\s+/g, '-');
    if (map[keyHyphen]) return map[keyHyphen];
    return null;
  }

  function lookupByHex(hex) {
    if (!hex) return null;
    var norm = (hex + '').toLowerCase().trim();
    var h = norm.replace(/^#/, '');
    return mapByHex[norm] || mapByHex[h] || mapByHex['#' + h] || null;
  }

  /** Resolve entry by fallback color hex (for translated labels e.g. Fekete -> same hex as Black). If direct hex has no image, try alias hexes (e.g. #add8e6 -> #90d5ff) so we still get the store's image. */
  function getEntryByFallbackHex(key) {
    var k = key && key.toLowerCase ? key.toLowerCase().trim() : key;
    var hex = fallbackColors[key] || fallbackColors[k] || fallbackColors[key.replace(/\s+/g, '')] || fallbackColors[key.replace(/\s+/g, '-')];
    if (!hex) return null;
    var norm = (hex + '').toLowerCase().trim();
    var entry = lookupByHex(norm);
    if (entry && entry.image) return entry;
    var aliases = fallbackHexAliases[norm] || fallbackHexAliases['#' + norm.replace(/^#/, '')];
    if (aliases) {
      for (var i = 0; i < aliases.length; i++) {
        var alt = lookupByHex(aliases[i]);
        if (alt && alt.image) return alt;
      }
    }
    return entry || null;
  }

  function styleForColor(key, useImage) {
    var entry = getEntry(key);
    if (!entry) {
      entry = getEntryByFallbackHex(key);
    }
    /* When useImage is true, prefer an entry that has an image (e.g. from byHex) over a label entry without image (e.g. "fehér" -> no image in map, but byHex #ffffff has image). */
    if (useImage && entry && !entry.image) {
      var byHexEntry = getEntryByFallbackHex(key);
      if (byHexEntry && byHexEntry.image) entry = byHexEntry;
    }
    var image = useImage && entry && entry.image ? entry.image : null;
    var color = entry ? colorToString(entry.color) : '';
    if (!image && !color) {
      var k = key && key.toLowerCase ? key.toLowerCase().trim() : key;
      color = fallbackColors[key] || fallbackColors[k] || fallbackColors[key.replace(/\s+/g, '')] || fallbackColors[key.replace(/\s+/g, '-')];
    }
    if (!image && !color) return null;
    var style = '';
    if (image) {
      style += 'background-image:url(' + image + ');background-size:cover;background-position:center;';
    }
    if (color) {
      style += 'background-color:' + color + ';';
    }
    return style || null;
  }

  /** Canonical Shopify option name from bundle markup (not affected by UI translation). */
  function getBundleOptionName(pillContainer) {
    if (!pillContainer) return '';
    return (pillContainer.getAttribute('data-option-name') || '').trim().toLowerCase();
  }

  function getBundleOptionLabel(group) {
    if (!group) return '';
    var labelEl = group.querySelector('.bundle-option-label');
    if (!labelEl) return '';
    return (labelEl.textContent || '').trim().toLowerCase();
  }

  /**
   * Color option: prefer data-option-name (Color / Color - Image), fall back to label text.
   */
  function isColorOptionGroupByLabel(group, pillContainer) {
    var optionName = getBundleOptionName(pillContainer);
    if (optionName === 'color' || optionName.indexOf('color') === 0) return true;
    var normalized = getBundleOptionLabel(group).replace(/\s*-\s*image\s*$/i, '').trim();
    return normalized === 'color';
  }

  /** Flag option: prefer data-option-name=Flag; label may be translated (e.g. Zászló). */
  function isFlagOptionGroupByLabel(group, pillContainer) {
    var optionName = getBundleOptionName(pillContainer);
    if (optionName === 'flag') return true;
    var label = getBundleOptionLabel(group);
    if (label === 'flag') return true;
    var flagLabels = ['zászló', 'zastava', 'vlajka', 'flaga', 'steag', 'bandeira', 'drapeau', 'bandiera', 'bayrak'];
    return flagLabels.indexOf(label) !== -1;
  }

  var flagLabelAliases = {
    'czech republic': ['czechia', 'cz', 'czech-republic'],
    czechia: ['czech republic', 'cz', 'czech-republic'],
    cz: ['czech republic', 'czechia', 'czech-republic']
  };

  function getFlagEntry(key) {
    if (!key) return null;
    if (flagMap[key]) return flagMap[key];
    var keyLower = key && key.toLowerCase ? key.toLowerCase().trim() : key;
    if (flagMap[keyLower]) return flagMap[keyLower];
    var keyNoSpaces = key.replace(/\s+/g, '');
    if (flagMap[keyNoSpaces]) return flagMap[keyNoSpaces];
    var keyHyphen = key.replace(/\s+/g, '-');
    if (flagMap[keyHyphen]) return flagMap[keyHyphen];
    var aliases = flagLabelAliases[keyLower] || flagLabelAliases[keyHyphen];
    if (aliases) {
      for (var i = 0; i < aliases.length; i++) {
        if (flagMap[aliases[i]]) return flagMap[aliases[i]];
      }
    }
    return null;
  }

  function styleForFlag(key) {
    var entry = getFlagEntry(key);
    if (!entry || !entry.image) return null;
    return 'background-image:url(' + entry.image + ');background-size:104%;background-position:center;';
  }

  /** "Color - Image" => use image swatch; "Color" => use color swatch. */
  function optionGroupWantsImageSwatch(pillContainer) {
    var optionName = getBundleOptionName(pillContainer);
    if (optionName.indexOf('- image') !== -1) return true;
    var group = pillContainer.closest('.bundle-option-group');
    var text = getBundleOptionLabel(group);
    return text.indexOf('- image') !== -1 || text.indexOf(' - image') !== -1;
  }

  function injectSwatchPills(pillContainer, getStyleForValue, extraSwatchClass) {
    pillContainer.classList.add('bundler-is-color');
    var swatchClassName = 'bundler-color-swatch' + (extraSwatchClass ? ' ' + extraSwatchClass : '');
    var pills = pillContainer.querySelectorAll('.bundle-pill');
    pills.forEach(function (pill) {
      var value = (pill.getAttribute('data-value') || '').trim();
      var valueLower = value.toLowerCase();
      if (!valueLower) return;
      pill.setAttribute('aria-label', value);
      var style = getStyleForValue(valueLower) || getStyleForValue(valueLower.replace(/\s+/g, ' '));
      pill.style.display = '';
      pill.removeAttribute('data-bundler-hidden-no-image');
      var swatch = pill.querySelector('.bundler-color-swatch');
      if (swatch) {
        if (extraSwatchClass) swatch.classList.add(extraSwatchClass);
        if (style) swatch.setAttribute('style', style);
        swatch.setAttribute('title', value);
        return;
      }
      swatch = document.createElement('span');
      swatch.className = swatchClassName;
      swatch.setAttribute('aria-hidden', 'true');
      swatch.setAttribute('title', value);
      if (style) swatch.setAttribute('style', style);
      pill.insertBefore(swatch, pill.firstChild);
    });
  }

  function injectSwatches(container) {
    if (!container) return;
    var allPillContainers = container.querySelectorAll('.bundle-pills-container');
    allPillContainers.forEach(function (pillContainer) {
      var group = pillContainer.closest('.bundle-option-group');
      if (isColorOptionGroupByLabel(group, pillContainer)) {
        var wantsImage = optionGroupWantsImageSwatch(pillContainer);
        if (wantsImage) {
          pillContainer.setAttribute('data-bundler-use-image', '1');
        } else if (pillContainer.getAttribute('data-bundler-use-image') === null) {
          pillContainer.setAttribute('data-bundler-use-image', '0');
        }
        var useImage = pillContainer.getAttribute('data-bundler-use-image') === '1';
        injectSwatchPills(pillContainer, function (valueLower) {
          return styleForColor(valueLower, useImage);
        });
        return;
      }
      if (isFlagOptionGroupByLabel(group, pillContainer)) {
        injectSwatchPills(pillContainer, function (valueLower) {
          return styleForFlag(valueLower);
        }, 'bundler-flag-swatch');
      }
    });
  }

  /** Remove " - Image" from bundle option labels (title) so it does not appear in the UI. */
  function stripImageFromLabels(container) {
    if (!container) return;
    var labels = container.querySelectorAll('.bundle-option-label');
    labels.forEach(function (labelEl) {
      var text = (labelEl.textContent || '').trim();
      var cleaned = text.replace(/\s*-\s*Image\s*$/gi, '').trim();
      if (cleaned !== text) labelEl.textContent = cleaned;
    });
  }

  /** Hardcoded translations for bundle option labels (Type, Size, Color). Keys match English app output; run after stripImageFromLabels. */
  var bundleLabelTranslations = {
    'Color': { en: 'Color', hr: 'Boja', cs: 'Barva', hu: 'Szín', pl: 'Kolor', ro: 'Culoare', sk: 'Farba', sl: 'Barva' },
    'Color - Image': { en: 'Color - Image', hr: 'Boja - Slika', cs: 'Barva - Obrázek', hu: 'Szín - Kép', pl: 'Kolor - Obraz', ro: 'Culoare - Imagine', sk: 'Farba - Obrázok', sl: 'Barva - Slika' },
    'Size': { en: 'Size', hr: 'Veličina', cs: 'Velikost', hu: 'Méret', pl: 'Rozmiar', ro: 'Mărime', sk: 'Veľkosť', sl: 'Velikost' },
    'Type': { en: 'Type', hr: 'Vrsta', cs: 'Typ', hu: 'Típus', pl: 'Typ', ro: 'Tip', sk: 'Typ', sl: 'Vrsta' },
    'Flag': { en: 'Flag', hr: 'Zastava', cs: 'Vlajka', hu: 'Zászló', pl: 'Flaga', ro: 'Steag', sk: 'Vlajka', sl: 'Zastava' }
  };
  var bundleLabelKeys = ['Color - Image', 'Color', 'Flag', 'Size', 'Type'];

  function translateBundleLabels(container) {
    if (!container) return;
    var locale = (document.documentElement.getAttribute('lang') || 'en').toLowerCase().split('-')[0];
    var t = bundleLabelTranslations;
    var labels = container.querySelectorAll('.bundle-option-label');
    labels.forEach(function (labelEl) {
      var text = (labelEl.textContent || '').trim();
      if (!text) return;
      for (var i = 0; i < bundleLabelKeys.length; i++) {
        var key = bundleLabelKeys[i];
        if (text === key || text.toLowerCase() === key.toLowerCase()) {
          var tr = t[key][locale] || t[key].en;
          if (tr && tr !== text) labelEl.textContent = tr;
          return;
        }
      }
    });
  }

  /** Get product name from item: img alt or first option label (text before " - Size" / " - Color"). */
  function getProductNameFromItem(item) {
    var img = item.querySelector('.bundle-product-image');
    if (img && (img.getAttribute('alt') || '').trim()) return (img.getAttribute('alt') || '').trim();
    var firstLabel = item.querySelector('.bundle-option-label');
    if (firstLabel) {
      var text = (firstLabel.textContent || '').trim();
      var idx = text.search(/\s*-\s*(?:Size|Color|Image)/i);
      if (idx !== -1) return text.slice(0, idx).trim();
      return text;
    }
    return '';
  }

  /** Insert product name and wrap image + name in a title block. */
  function injectProductNames(container) {
    if (!container) return;
    var items = container.querySelectorAll('.bundle-product-item');
    items.forEach(function (item) {
      if (item.querySelector('.bundle-product-name')) return;
      var name = getProductNameFromItem(item);
      if (!name) return;
      var nameEl = document.createElement('h4');
      nameEl.className = 'bundle-product-name';
      nameEl.textContent = name;
      item.insertBefore(nameEl, item.firstChild);
      var imageContainer = item.querySelector('.bundle-product-image-container');
      var nameInItem = item.querySelector('.bundle-product-name');
      if (imageContainer && nameInItem) {
        var wrapper = document.createElement('div');
        wrapper.className = 'bundle-product-title-block';
        wrapper.setAttribute('role', 'button');
        wrapper.setAttribute('tabindex', '0');
        wrapper.setAttribute('aria-expanded', 'true');
        wrapper.appendChild(imageContainer);
        wrapper.appendChild(nameInItem);
        var caretSpan = document.createElement('span');
        caretSpan.className = 'svg-wrapper icon-caret bundle-product-title-block__caret';
        caretSpan.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
        wrapper.appendChild(caretSpan);
        item.insertBefore(wrapper, item.firstChild);
        wrapper.addEventListener('click', function () {
          item.classList.toggle('is-details-collapsed');
          wrapper.setAttribute('aria-expanded', item.classList.contains('is-details-collapsed') ? 'false' : 'true');
        });
        wrapper.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            wrapper.click();
          }
        });
      }
    });
  }

  var _mapsLogged = false;
  var _byHexFetched = false;
  /** Fetch byHex from default locale page and merge into mapByHex so non-default locales (e.g. Slovak) get all color images. */
  function fetchByHexFromDefaultLocale() {
    if (_byHexFetched) return Promise.resolve();
    var locale = (document.documentElement.getAttribute('lang') || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    var count = Object.keys(mapByHex).filter(function (k) { return mapByHex[k] && mapByHex[k].image; }).length;
    if (locale === 'en' || count >= 6) return Promise.resolve();
    _byHexFetched = true;
    var url = window.location.pathname.indexOf('/') === 0 ? window.location.origin + '/pages/color-pattern-map?locale=en' : '/pages/color-pattern-map?locale=en';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById('bundler-color-byhex-json');
        if (!el || !el.textContent) return;
        try {
          var data = JSON.parse(el.textContent.trim());
          if (data && typeof data === 'object') {
            for (var k in data) {
              if (data[k] && data[k].image && (!mapByHex[k] || !mapByHex[k].image))
                mapByHex[k] = data[k];
            }
          }
        } catch (e) {}
      })
      .catch(function () { _byHexFetched = false; });
  }

  function run() {
    var root = document.getElementById('bundlerAppProducts') || document.getElementById('optionsBundle');
    if (!root) return;
    if (!_mapsLogged) {
      _mapsLogged = true;
      debugLogMaps();
    }
    injectSwatches(root);
    stripImageFromLabels(root);
    translateBundleLabels(root);
    injectProductNames(root);
  }

  function scheduleRun() {
    var root = document.getElementById('bundlerAppProducts') || document.getElementById('optionsBundle');
    run();
    var locale = (document.documentElement.getAttribute('lang') || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    var hexWithImageCount = Object.keys(mapByHex).filter(function (k) { return mapByHex[k] && mapByHex[k].image; }).length;
    if (locale !== 'en' && hexWithImageCount < 6) {
      fetchByHexFromDefaultLocale().then(function () { run(); });
    }
    if (root && !root._bundlerSwatchObserved) {
      root._bundlerSwatchObserved = true;
      var observer = new MutationObserver(function () {
        observer.disconnect();
        run();
        setTimeout(function () {
          if (root.parentNode) observer.observe(root, { childList: true, subtree: true });
        }, 200);
      });
      observer.observe(root, { childList: true, subtree: true });
      root._bundlerSwatchObserver = observer;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleRun();
      setTimeout(scheduleRun, 800);
    });
  } else {
    scheduleRun();
    setTimeout(scheduleRun, 800);
  }
})();
